/**
 * @generated SignedSource<<6a0864f66d0933ae36483508229686fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoListItemHeader_todo$data = {
  readonly createdByActor: {
    readonly " $fragmentSpreads": FragmentRefs<"CreatedBySubject_actor">;
  } | null;
  readonly isIssue: boolean;
  readonly subject: {
    readonly " $fragmentSpreads": FragmentRefs<"TodoSubject_TodoSubject">;
  } | null;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemHeaderWrapper_todo">;
  readonly " $fragmentType": "TodoListItemHeader_todo";
};
export type TodoListItemHeader_todo$key = {
  readonly " $data"?: TodoListItemHeader_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemHeader_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemHeader_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemHeaderWrapper_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubject",
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoSubject_TodoSubject"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isIssue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "createdByActor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CreatedBySubject_actor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "c63b7608e2bf00bd870ab9188d37f090";

export default node;
